import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery } from 'react-fetching-library';
import { Button, FormControl, Stack, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import * as requests from '../../services/request';
import { CssTextField } from '../others/CssTextField';
import { constructDependsOnParams, handleShowOn } from '../../services/functions';

export const SubmitCharField = props => {
  const { field, formik, getFieldCallback, metaData } = props;
  const [searchParams] = useSearchParams();

  const discountCodes = searchParams
    .get('discount_codes')
    ?.split(',')
    .filter(code => code.length > 0) ?? [];

  const action = requests[field.on_change];
  const { query, loading } = useParameterizedQuery(action);

  function ToastContent({ t, message }) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span>{message}</span>

        <IconButton
          size="small"
          onClick={() => toast.dismiss(t.id)}
          sx={{
            ml: 1,
            p: 0.5,
            color: 'inherit',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.08)'
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    );
  }

  function showToast(message, type) {
    const commonOptions = {
      position: 'top-center',
      duration: Infinity
    };

    switch (type) {
    case 'success':
      toast.success(
        t => <ToastContent t={t} message={message} />,
        commonOptions
      );
      break;

    case 'error':
      toast.error(
        t => <ToastContent t={t} message={message} />,
        commonOptions
      );
      break;

    case 'warning':
      toast(
        t => <ToastContent t={t} message={message} />,
        {
          ...commonOptions,
          style: {
            background: '#facc15',
            color: '#000'
          }
        }
      );
      break;

    default:
      toast(
        t => <ToastContent t={t} message={message} />,
        commonOptions
      );
    }
  }
  const submitDiscountCode = async (discountCode, discountCode_promotions) => {
    const { payload } = await query(
      constructDependsOnParams(
        field.depends_on,
        field.name,
        {
          ...formik.values,
          [field.name]: discountCode,
          discount_code_promotions: discountCode_promotions ? discountCode_promotions : formik.values.discount_code_promotions
        }
      )
    );
    if (_.isObject(payload) && payload.request_type === 'obozy_discount_code') {
      formik.setFieldValue('discount_code_promotions', payload.discount_code_promotions);

      if (payload.toast && payload.message) {
        showToast(payload.message, payload.toast);
      }
    }

    formik.setFieldValue(field.name, '');
  };

  const handleSubmit = async () => {
    if (field.on_change) {
      if (field.name == 'discount_code') {
        await submitDiscountCode(formik.values[field.name]);

      } else {
        query(formik.values[field.name]);
      }
    }
    formik.setFieldValue(field.name, '');
  };

  const handleResetDiscountCodePromotions = () => {
    formik.setValues(prev => ({
      ...prev,
      discount_code_promotions: []
    }));
  };

  React.useEffect(() => {
    if (
      field.name !== 'discount_code' ||
      !formik.values.camp ||
      discountCodes.length === 0
    ) {
      return;
    }

    const timeout = setTimeout(() => {
      submitDiscountCode(discountCodes[0], []);
    }, 300);

    return () => clearTimeout(timeout);
  }, [formik.values.camp]);

  return (
    <FormControl style={{ paddingBottom: 15, display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}
    fullWidth >
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
      </Typography>
      <Stack direction="row" spacing={2}>
        <CssTextField
          element={CssTextField}
          type="char"
          name={field.name}
          label={field.placeholder}
          value={formik.values[field.name]}
          onChange={e => formik.setFieldValue(field.name, e.target.value)}
          variant="outlined"
        />
        <Button color="primary" onClick={handleSubmit} variant="contained" disabled={loading}>
        Zatwierdź
        </Button>
        {formik.values.discount_code_promotions?.length > 0 && (
          <Button
            color="error"
            variant="outlined"
            onClick={handleResetDiscountCodePromotions}
            sx={{ textTransform: 'none' }}
          >
            Usuń dodane promocje z kodem rabatowym
          </Button>
        )}
      </Stack>
    </FormControl>
  );
};
